/**
 * AdminConfigCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {AdminConfig} from '@/model/resource/AdminConfig'

/* TODO: review generated class */
@HttpExclude()
export class AdminConfigCollection extends PageCollection<AdminConfig> {
  constructor() {
    super(AdminConfig)
  }

  queryAsPage() {
    return this.listAdminConfig()
  }

  async listAdminConfig() {
    return await Request.get(`/admin/admin-config`, {params: this.params})
      .name('listAdminConfig')
      .as(this)
      .getResponse()
  }

  async listCsvAdminConfig() {
    return await Request.get(`/admin/admin-config/csv`, {params: this.params})
      .name('listCsvAdminConfig')
      .as(this)
      .getResponse()
  }
}
